import React from 'react';

export default {
  svg: (
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M3.9799 6.3502 7.35 2.98v3.3703H3.98Zm18.835 9.0803h-4.5267l-1.291 3.3676-4.3937-12.2847-3.2465 8.6733H2.8072V8.1575h6.3501V1.8072h6.8087V11.6c0 .4992.4046.9036.9036.9036a.9036.9036 0 0 0 .9037-.9036V0H8.1766a.96.96 0 0 0-.4917.1357.9024.9024 0 0 0-.1914.145L1.2833 6.491a.906.906 0 0 0-.117.1436.9632.9632 0 0 0-.1663.542v15.002h12.4547a.9036.9036 0 0 0 .9036-.9035.9036.9036 0 0 0-.9036-.9037H2.8072V16.994h7.803l1.9547-5.222L16.9383 24l2.5925-6.7623h3.284a.9036.9036 0 0 0 0-1.8072Z"
        fill="#222"
      />
    </g>
  ),
  viewBox: '0 0 24 24'
};
